const parseBarcodeNumber = (itemNumber) => {
    const trimmed = typeof itemNumber === 'string' ? itemNumber.trim() : ''
    if (!trimmed) return false

    const barcode = trimmed.includes('#') ? trimmed : '#' + trimmed

    const regex = /#(\d+)_(\d+)/gi
    const parsed = regex.exec(barcode)

    if (!parsed || parsed.length !== 3) return false

    const [_barcode, number, index] = parsed

    const vNumber = number > 0 ? parseInt(number, 10) : 0
    const vIndex = index > 0 ? parseInt(index, 10) : 0

    return {
        barcode: _barcode,
        number: vNumber,
        index: vIndex,
    }
}

export default parseBarcodeNumber

